import React from 'react'

function GrayGradient(): JSX.Element {
    return (
        <defs>
            <linearGradient id="gray-gradient" x1="0" y1="0" x2="0" y2="25" gradientUnits="userSpaceOnUse">
                <stop offset="0%" stopColor="white" stopOpacity="1" />
                <stop offset="100%" stopColor="white" stopOpacity="0.15" />
            </linearGradient>
        </defs>
    )
}

export default function useSvgGradient(variant: 'gray' = 'gray'): [string, React.ReactNode] {
    return ['url(#gray-gradient)', <GrayGradient />]
}
